<template>
    <b-modal id="modal-component" :title="$props.modal.title" :hide-header=true :hide-footer=true size="xl">
        <div class="row">
            <div v-if="this.$props.modal.image != null" class="col-md-6 bg-image" :style="{'background-image':`url('${this.$props.modal.image_url}')`}">
            </div>
            <div class="col-12 content text-center" :class="{'col-md-6':(this.$props.modal.image != null)}">
                <button type="button" class="close" data-dismiss="modal" @click="$bvModal.hide('modal-component')"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                <h4>{{ $props.modal.translations.find(o=>o.locale==$i18n.locale).title }}</h4>
                <div v-html="$props.modal.translations.find(o=>o.locale==$i18n.locale).content"></div>
                <div v-if="$props.modal.translations.find(o=>o.locale==$i18n.locale).action.length >0 && $props.modal.translations.find(o=>o.locale==$i18n.locale).action_title.length >0">
                    <a :href="$props.modal.translations.find(o=>o.locale==$i18n.locale).action" class="w-100 btn btn-outline-primary" >{{ $props.modal.translations.find(o=>o.locale==$i18n.locale).action_title }}</a>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "Modal",
    props: {
        modal: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.$bvModal.show('modal-component');
    },
    updated(){
        this.$bvModal.show('modal-component');
    }
}
</script>

<style scoped>
/deep/ #modal-component .modal-body{padding: 0px;margin-bottom: -15px;overflow:hidden;}
/deep/ #modal-component .bg-image{background-position: left bottom;background-size:cover;background-repeat: no-repeat;min-height:250px;}
/deep/ #modal-component .content{background-color: #fff;padding: 30px;border-radius: 0px 4px 4px 0px;}
/deep/ #modal-component .close{border:none;position: absolute;right: 0px;top:0px;font-size: 22px;background-color: transparent;background-color: #000;color: #fff;}
/deep/ #modal-component .row{margin-bottom: 15px;}
/deep/ #modal-component .form-group{width: 100%;margin-bottom: 15px;padding-left: 15px;padding-right: 15px;}
/deep/ #modal-component .form-group .form-control{width: 100%;}
/deep/ #modal-component .form-group .form-control-feedback{top: 14px;right: 10px;}
/*@media(max-width: 800px){/deep/ #modal-component .modal-content{padding-top: 200px;background-position: 0px 200px;background-repeat: repeat-y;}/deep/ #modal-component .content{width:100%;border-radius: 0px 0px 4px 4px;}/deep/ #modal-component .form-group{width: 50%;margin-bottom: 0px;float: left;}/deep/ #modal-component .close{top:-200px;}}
@media(max-width: 450px){/deep/ #modal-component .form-group{width: 100%;margin-bottom: 15px;padding-left: 15px;padding-right: 15px;}}*/
/deep/ #modal-component .modal-body img{max-width:100%;height:auto;}
</style>
